import { render, staticRenderFns } from "./PricingTariffsCard.vue?vue&type=template&id=5a98ea09"
import script from "./PricingTariffsCard.vue?vue&type=script&lang=js"
export * from "./PricingTariffsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports